<template>
  <header class="saction-header">
    <div class="group">
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: "saction-header"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/scss/vars.scss";

.saction-header {
  margin-bottom: 2em;
  border-bottom: 1.5px solid #bebebe;
  font-size: 0.5em;
}

.group {
  border-bottom: 1.5px solid $primary;
  display: inline-block;
  padding-bottom: 1.5em;
  margin-bottom: -2px;
}

h1 {
  font-weight: 700;
  margin: 0;
  font-size: 3em;
}
</style>
